module.exports = __webpack_public_path__ + "static/media/shopify1.6376391e.png";